import * as React from "react";

 class  httpToken {
  
  cacheKey: string = "Token";
  constructor(){}
  
  GetCachedToken () : String  { return String(localStorage.getItem(this.cacheKey)); }
  SetCachedToken(value : String) {localStorage.setItem(this.cacheKey, String(value));}

}

export default httpToken;